 export default f => f()
